<template>
	<div class="body-container">
		<headerNavigation :showLogin="false"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="site-main-container">
			<div class="page-portal-container container">
				<div class="site-container">
					<userHeader :subMenuIndex="1"></userHeader>
					<div class="comp-settings-contact-information-container">
						<div class="comp-settings-left-nav-container hidden-xs hidden-sm">
							<ul class="left-nav-list list-group aria-parent-nav">
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a class="active-sub-tab" href="javascript:void(0)">
										<span class="left-nav-label pull-left">{{$t('common.accountdetail')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" @click="openPage('password')">
										<span class="left-nav-label pull-left">{{$t('user.changepassword')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" @click="openPage('address')">
										<span class="left-nav-label pull-left">{{$t('user.addressbook')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" @click="openPage('paymethod')">
										<span class="left-nav-label pull-left">{{$t('user.paymentmethod')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
							</ul>
						</div>
						<div class="comp-settings-left-nav-mobile-container hidden-md hidden-lg">
							<div class="left-nav-mobile-container collapse navbar-collapse">
								<ul class="left-nav-ul nav navbar-nav" >
									<li class="left-nav-dropdown dropdown" :class="showSubMenu ? 'open' : ''">
										<a href="javascript:void(0)" class="left-nav-active-page dropdown-toggle" @click="changeSubMenu">
											<span class="left-nav-active-label">{{$t('common.accountdetail')}}</span>
											<img src="../../assets/images/arrow-down.png" class="dri-arrow-down dropdown-icon pull-right down-icon"/>
										</a>
										<ul class="left-nav-subnav dropdown-menu">
											<li class="left-nav-links">
												<a href="javascript:void(0)" class="left-nav-url">{{$t('common.accountdetail')}}</a>
											</li>
											<li class="left-nav-links">
												<a href="javascript:void(0)" @click="openPage('password')" class="left-nav-url">{{$t('user.changepassword')}}</a>
											</li>
											<li class="left-nav-links">
												<a href="javascript:void(0)" @click="openPage('address')" class="left-nav-url">{{$t('user.addressbook')}}</a>
											</li>
											<li class="left-nav-links">
												<a href="javascript:void(0)" @click="openPage('paymethod')" class="left-nav-url">{{$t('user.paymentmethod')}}</a>
											</li>
										</ul>
									</li>
								</ul>
							</div>
						</div>
						<div class="contact-information-container">
							<h3 class="contact-information-label">{{$t('common.accountdetail')}}</h3>
							<div class="form-container form-horizontal ng-untouched ng-pristine ng-valid">
								<!-- <div class="form-holder form-group site-form-group">
									<label class="form-label control-label">{{$t('login.email')}}</label>
									<div class="form-field-container site-input-group">
										<input type="text" maxlength="50" autocomplete="off" class="site-form-input form-field form-control first-focus-element ng-untouched ng-pristine has-value ng-valid">
									</div>
								</div> -->
								<div class="form-holder form-group site-form-group">
									<label class="form-label control-label">{{$t('user.firstname')}}</label>
									<div class="form-field-container site-input-group">
										<input v-model="firstname" type="text" maxlength="30" autocomplete="off" class="site-form-input form-field form-control first-focus-element ng-untouched ng-pristine has-value ng-valid">
									</div>
								</div>
								<div class="form-holder form-group site-form-group">
									<label class="form-label control-label">{{$t('user.lastname')}}</label>
									<div class="form-field-container site-input-group">
										<input v-model="lastname" type="text" maxlength="30" autocomplete="off" class="site-form-input form-field form-control first-focus-element ng-untouched ng-pristine has-value ng-valid">
									</div>
								</div>
								<div class="form-holder form-group site-form-group">
									<label class="form-label control-label">{{$t('user.nickname')}}</label>
									<div class="form-field-container site-input-group">
										<input v-model="nickname" type="text" maxlength="30" autocomplete="off" class="site-form-input form-field form-control first-focus-element ng-untouched ng-pristine has-value ng-valid">
									</div>
								</div>
								<div class="form-btn-container form-holder form-group">
									<div class="pull-left">
										<button class="site-btn-primary" @click="doConfirm">
											<span>{{$t('common.update')}}</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loading v-if="isLoading"></loading>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import userHeader from '../../components/userHeader.vue'
	import loading from '../../components/loading.vue'
	import {updateAccount,getAccountInfos} from '../../api/api.js'
	export default {
		components: {
			headerNavigation,
			footers,
			userHeader,
			loading
		},
		data() {
			return {
				isMobile:false,
				showSubMenu:false,
				isLoading:false,
				firstname:'',
				lastname:'',
				nickname:''
			};
		},
		mounted() {
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.init()
		},
		methods: {
			init(){
				var that = this;
				let params = {}
				getAccountInfos(params).then(res => {
					if (res.code == 200) {
						that.firstname = res.data.memberDtlItem.firstname
						that.lastname = res.data.memberDtlItem.lastname
						that.nickname = res.data.memberDtlItem.nickname
					}
				})
			},
			changeSubMenu(){
				this.showSubMenu = !this.showSubMenu
			},
			verification() {
				if(!this.firstname){
					this.$message.warning(this.$t('tips.pleaseinputfirstname'));
					return false;
				}
				if(!this.lastname){
					this.$message.warning(this.$t('tips.pleaseinputlastname'));
					return false;
				}
				if(!this.nickname){
					this.$message.warning(this.$t('tips.pleaseinputnickname'));
					return false;
				}
				return true;
			},
			doConfirm(){
				if(this.verification()){
					var that = this;
					let params = {
						firstname:this.firstname,
						lastname:this.lastname,
						nickname:this.nickname
					}
					that.isLoading = true
					updateAccount(params).then(res => {
						that.isLoading = false
						if (res.code == 200) {
							that.$message.success(res.msg);
							localStorage.setItem('nickname', that.nickname);
							setTimeout(() => {
							    that.refreshPage()
							}, 1000);
						}else{
							that.$message.warning(res.msg);
							return false;
						}
						
					})
				}
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/user.css");
	.global-header-spacer {
	    height: 50px !important;
	    display: block !important;
	}
</style>